import { Component, OnInit, Input, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { AppState } from '../../core/app-state';
import { ScoutTaskDoc } from '../../core/schema/scout-task-schema';
import {BuildingDoc, BuildingService, PointService, ScoutTaskService, UserService } from '../../core/services';
import { ScoutPath, ScoutPoint } from '../../core/models/scout-task';
import { TaskStatus, activity_status } from '../../core/models/task-status';
import { ShowRequest } from '../../core/show-request';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { v4 as uuidv4 } from 'uuid'
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { ScoutPointRefDialogComponent } from '../scout-point/scout-point-ref-dialog/scout-point-ref-dialog.component';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppTab } from '../../core/app-tab';
import { RoleMgr } from '../../core';
import { ScoutPointPhotoBrowserComponent, ScoutPointPhotoSelected } from '../scout-point/scout-point-photo-browser/scout-point-photo-browser.component';
import { ScoutPointPhotoModal } from '../scout-point/scout-point-photo-modal/scout-point-photo-modal.component';
import { TaskEditComponent } from '../../task/task-edit/task-edit.component';
import { ScoutKmlViewerModal } from '../scout-kml-viewer/scout-kml-viewer-modal/scout-kml-viewer-modal.component';



@Component({
  selector: 'app-scout-view',
  templateUrl: './scout-view.component.html',
  styleUrls: ['./scout-view.component.scss']
})
export class ScoutViewComponent extends FesBaseComponent implements OnInit, OnDestroy {

  @Input() scoutTask : ScoutTaskDoc

  @Input() set tabConfig( tabConfig : AppTab ) {
    tabConfig.setSelected = this.onTabSelected
    tabConfig.hasUnsavedData = this.hasUnsavedData
  }
  
  @Input() public detailFn : (vi: ShowRequest) => void;

  @ViewChildren(ScoutPointPhotoBrowserComponent) photoBrowsers!: QueryList<ScoutPointPhotoBrowserComponent>;

  building : BuildingDoc
  scoutPaths : ScoutPath[]
  bShowPhotoSummary = false
  bProcessing = false

  canDeleteByStatusId : { [id:string]: boolean} = {
    [activity_status.Id.NOT_STARTED]: true,
    [activity_status.Id.IN_PROGRESS]: true,
  }

  userIsAdminOrPm = false
  
  constructor(appState : AppState, 
      protected buildingService : BuildingService,
      protected pointService : PointService,
      protected scoutTaskService : ScoutTaskService,
      private bsModalService: BsModalService,
      private userService: UserService,
      private router: Router,
      public roleMgr: RoleMgr,
              ) {
    super(appState)
  }

  userRole : string
  ngOnInit(): void {
    this.subscribe( this.appState.userSubject, (user) => { 
      this.userRole = user?.role; 
      this.userIsAdminOrPm = ['admin','pm'].includes(this.userRole)
    })
  }

  ngOnDestroy(): void {
    super.destroy()
  }

  hasUnsavedData = () => {
    return this.scoutModal?.isEditing && this.scoutModal?.isModified()
  }


  initialize() {
    let taskObj = this.scoutTask as any
    this.scoutPaths = this.scoutTask.scoutPaths
    this.subscribe( this.scoutTask.get$('scoutPaths'), async scoutPaths => { 

      ScoutPath.sortByPathNumber(scoutPaths)

      for( let i = 0; i < scoutPaths?.length; i++ ) {
        let scoutPath = scoutPaths[i];
        if ( scoutPath.userId ) {
          try {
            const userDoc = await this.userService.rxCollection.findOne(scoutPath.userId).exec()
            scoutPath.userName = userDoc.email
          } catch ( error ) {
            console.warn('No user found for ' + scoutPath.userId)
          }
        }

        if( !scoutPath.statusId ){
          scoutPath.statusId = activity_status.Id.IN_PROGRESS;
          (scoutPath as any).statusName = activity_status.Names.IN_PROGRESS
        } else{
          (scoutPath as any).statusName = activity_status.Names[scoutPath.statusId]
        }

        (scoutPath as any).uiLocked = TaskStatus.uiLockHandler(scoutPath.statusId, this.roleMgr.canEditUsers)

        if ( scoutPath.scoutPoints.length > 0 ) {
          const haPt : ScoutPoint = scoutPath.scoutPoints.find(pt=>!pt.parentId&&pt.type=='HA');
          try{
            this.scoutTaskService.updateScoutPathContext(scoutPath, [])
          } catch ( error ) {
            console.warn('failed intializing scout path computed data')
          }
          (scoutPath as any).haPoint = haPt
        }
      }
      this.scoutPaths = scoutPaths || []
    })
    this.subscribe( this.scoutTask.get$('buildingId'), buildingId => {
      this.buildingService.rxCollection.findOne(this.scoutTask.buildingId).exec().then( 
        buildingDoc => {
          taskObj.buildingDoc = buildingDoc
          this.building = buildingDoc                  
        }
      )
    })
  }


  onReportDoc( scoutPath: ScoutPath, evt : MouseEvent ) {
    if ( evt.ctrlKey ) {
      // still allow full page as an easter egg just incase full url needs to be passed
      let url = '#' + this.router.createUrlTree(['scout', 'path-report', this.scoutTask._id, scoutPath.id],
      { queryParams: { wideMapZoomLevel: 19, detailMapZoomLevel: '', leafletMapToImageWaitSecs: 10, maxImageWidth: 1024, maxImageHeight: 1024 } }).toString()  
      window.open( url, 'ScoutPathReport-'+scoutPath.id );
    } else {
      this.detailFn( new ShowRequest('tab', 'scout report', scoutPath.id, this.scoutTask) )
    }
  }


  onReportData( scoutPaths: ScoutPath[], evt : MouseEvent ) {
    const strContext = JSON.stringify({ pathIds: scoutPaths.map(path=>path.id) })
    this.detailFn( new ShowRequest('tab', 'scout data report', strContext, this.scoutTask) )
  }

  onShowKml( scoutPaths: ScoutPath[], evt : MouseEvent ) {
    ScoutKmlViewerModal.show(this.bsModalService,{ scoutTaskDoc: this.scoutTask, pathIds: scoutPaths.map(path=>path.id) })   
  }

  async onEdit( evt : MouseEvent ) {
    //this.detailFn( new ShowRequest('tab', 'schedule task', this.scoutTask._id, this.scoutTask) )
    const initialState = {          
    }
    const modalRef = this.bsModalService.show(TaskEditComponent, {
      ignoreBackdropClick: true, 
      class: 'modal-lg',
      initialState
    });
    const taskEditComponent: TaskEditComponent = modalRef.content
    taskEditComponent.setTaskDoc(this.scoutTask)
    await modalRef.onHidden.pipe(first()).toPromise()
  }

  onDeleteScoutPath( scoutPath: ScoutPath ) {
    let initialState = null
    
    const canDelete = this.canDeleteByStatusId[scoutPath.statusId] && this.userIsAdminOrPm

    if ( !canDelete ) {
      initialState = {
        yesBtnText: null,
        noBtnText: 'OK',      
        title: `Cannot Delete Scout Path`,
        question: "<div class='m-2 small font-italic text-danger'>"
            + `<i class='text-warning fa fa-exclamation-triangle mr-1'></i>
            Scout status is ${activity_status.Names.byId(scoutPath.statusId)}.
            User role is ${this.userRole} (admin or pm role required).</div>
            <div class="pt-2">Cannot delete scout path #${scoutPath.pathNumber}.</div>`,
        focusOnNo: true        
      }
    } else { 
      initialState = {
        onYes: async () => {
          this.bProcessing = true
          try {
            this.scoutTaskService.deleteScoutPathAndPhotos(this.scoutTask,scoutPath)
          } catch ( error ) {
            this.scoutTaskService.publishErrorObj(error,
              `Delete scout path #${scoutPath.pathNumber} for building ${this.scoutTask.buildingId} failed.`,this)
          }
          this.bProcessing = false
        },
        title: `Confirm Scout Path Deletion`,
        question: `<div class="m-2 small font-italic text-danger">
            <i class='text-warning fa fa-exclamation-triangle mr-1'></i>
            Delete includes ${scoutPath.scoutPoints?.length} point(s)
          </div>
          <div class="pt-2">
            Delete scout path #${scoutPath.pathNumber} (building ${this.scoutTask.buildingId})?
          </div>`,
        focusOnNo: true,
        yesStyle: 'btn btn-danger'
      }
    }
    const modalRef = this.bsModalService.show(ConfirmModalComponent, {
        ignoreBackdropClick: true,
        id: 20211028,
        initialState
    });
  }

  onTabSelected = ( bSelected : boolean ) => {
    console.log('scout-view tab selected: ' + bSelected )
    if ( bSelected ) {
      this.initialize()
      this.photoBrowsers.forEach(pb=>pb.initPhotoWatch())
    } else {
      this.unsubscribe()
      this.photoBrowsers.forEach(pb=>pb.unsubscribe())
    }
  }

  async onEditScoutPath(scoutPath : ScoutPath) {
    this.detailFn( new ShowRequest('tab','scout path', scoutPath.id, this.scoutTask) )
  }

  onShowPoint( pointId: string ) {
    this.detailFn( new ShowRequest('tab','point', pointId, null) )
  }

  selectedPointId : string

  onShowScoutPointPhoto = ( photoSelectedEvt : ScoutPointPhotoSelected ) => {
      //console.log( JSON.stringify(photoSelectedEvt.photo.toJSON()))
      this.selectedPointId = photoSelectedEvt.point?.id
      let uiLocked = TaskStatus.uiLockHandler(photoSelectedEvt.path?.statusId, this.roleMgr.canEditUsers)      
      const context : ModalOptions = {
        initialState: {
          locked: uiLocked,
          ...photoSelectedEvt
        },
        class: 'photo-modal',
        id: ScoutPointPhotoModal.ModalId,
        animated: true,
        ignoreBackdropClick: true    
      } 
      const modalRef = this.bsModalService.show(ScoutPointPhotoModal, context );
  }

  onShowScoutPoint = ( scoutPoint: ScoutPoint, scoutPath: ScoutPath ) => {
    this.selectedPointId = scoutPoint?.id
    let uiLocked = TaskStatus.uiLockHandler(scoutPath.statusId, this.roleMgr.canEditUsers)
    const context : ModalOptions = {
      initialState: {
        scoutPointId: scoutPoint.id,
        scoutPathId: scoutPath.id,
        scoutTaskDoc: this.scoutTask,
        allowEditMode: true,
        locked: uiLocked
      },
      class: 'full-screen-modal',
      id: ScoutPointRefDialogComponent.ModalId,
      animated: true,      
      ignoreBackdropClick: true    
    } 
    const modalRef = this.bsModalService.show(ScoutPointRefDialogComponent, context );
    this.scoutModal = modalRef.content
    const pointChangeSubscription = 
        this.scoutModal.selectedPointChanged.subscribe((pt:ScoutPoint)=>{ this.selectedPointId = pt?.id })
    this.scoutModal.onClosed.pipe(first()).subscribe( () => {
      this.scoutModal = null
      pointChangeSubscription?.unsubscribe()
    })
  }
  scoutModal : ScoutPointRefDialogComponent

  async onAddPath() {
    let initialState = { 
      onYes: async () => { 
        try {    
          const newScoutPath = {
            id: uuidv4(),
            modifiedDate: this.scoutTaskService.nowTimeStamp(),
            userId: this.appState.getUser()._id,
            description: '',
            scoutPoints: [],
            buildingPointIds: [],
            comments: [],
            statusId: activity_status.Id.NOT_STARTED
          }    
          await this.scoutTask.atomicUpdate( (scoutTask) => {
            if ( !scoutTask.scoutPaths ) {
              scoutTask.scoutPaths = []
            }
            scoutTask.scoutPaths.push(newScoutPath)
            return scoutTask
          })
          this.detailFn( new ShowRequest('tab','scout path', newScoutPath.id, this.scoutTask) )
        } catch (error) {
          this.scoutTaskService.publishError(error,this)
        } finally {
          this.scoutTaskService.syncNow()
        }            
      },
      question: 'Create (save) a new scout path?',
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.bsModalService.config.animated = false    
    this.bsModalService.show(ConfirmModalComponent, {initialState} );
  }
}


